import React, { useState } from 'react';
import Header from '../../components/ui/Header';
import Icon from '../../components/AppIcon';
import AlgorithmSettings from './components/AlgorithmSettings';
import DisplayPreferences from './components/DisplayPreferences';
import SecuritySettings from './components/SecuritySettings';
import NotificationSettings from './components/NotificationSettings';
import AccountManagement from './components/AccountManagement';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('algorithm');

  const tabs = [
    {
      id: 'algorithm',
      label: 'Algorithm',
      icon: 'Settings',
      description: 'PTS-WIZARD-V3 Configuration'
    },
    {
      id: 'display',
      label: 'Display',
      icon: 'Monitor',
      description: 'Interface & Appearance'
    },
    {
      id: 'security',
      label: 'Security',
      icon: 'Shield',
      description: 'Account Security'
    },
    {
      id: 'notifications',
      label: 'Notifications',
      icon: 'Bell',
      description: 'Alerts & Messages'
    },
    {
      id: 'account',
      label: 'Account',
      icon: 'User',
      description: 'Profile & Subscription'
    }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'algorithm':
        return <AlgorithmSettings />;
      case 'display':
        return <DisplayPreferences />;
      case 'security':
        return <SecuritySettings />;
      case 'notifications':
        return <NotificationSettings />;
      case 'account':
        return <AccountManagement />;
      default:
        return <AlgorithmSettings />;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      {/* Main Content */}
      <div className="pt-[60px] pb-[80px] md:pb-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Page Header */}
          <div className="mb-8">
            <div className="flex items-center space-x-3 mb-2">
              <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
                <Icon name="Settings" size={20} color="white" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-foreground">Settings</h1>
                <p className="text-muted-foreground">Configure your CryptoWizard Pro experience</p>
              </div>
            </div>
          </div>

          <div className="flex flex-col lg:flex-row gap-8">
            {/* Sidebar Navigation */}
            <div className="lg:w-80 flex-shrink-0">
              <div className="bg-card border border-border rounded-lg p-4">
                <nav className="space-y-2">
                  {tabs?.map((tab) => (
                    <button
                      key={tab?.id}
                      onClick={() => setActiveTab(tab?.id)}
                      className={`w-full flex items-center space-x-3 px-4 py-3 rounded-md text-left transition-colors duration-200 ${
                        activeTab === tab?.id
                          ? 'bg-primary text-primary-foreground'
                          : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                      }`}
                    >
                      <Icon name={tab?.icon} size={18} />
                      <div className="flex-1">
                        <div className="text-sm font-medium">{tab?.label}</div>
                        <div className="text-xs opacity-80">{tab?.description}</div>
                      </div>
                    </button>
                  ))}
                </nav>

                {/* Quick Actions */}
                <div className="mt-6 pt-4 border-t border-border">
                  <h4 className="text-sm font-medium text-foreground mb-3">Quick Actions</h4>
                  <div className="space-y-2">
                    <button className="w-full flex items-center space-x-2 px-3 py-2 text-sm text-muted-foreground hover:text-foreground hover:bg-muted rounded-md">
                      <Icon name="Download" size={14} />
                      <span>Export Settings</span>
                    </button>
                    <button className="w-full flex items-center space-x-2 px-3 py-2 text-sm text-muted-foreground hover:text-foreground hover:bg-muted rounded-md">
                      <Icon name="Upload" size={14} />
                      <span>Import Settings</span>
                    </button>
                    <button className="w-full flex items-center space-x-2 px-3 py-2 text-sm text-muted-foreground hover:text-foreground hover:bg-muted rounded-md">
                      <Icon name="RotateCcw" size={14} />
                      <span>Reset All</span>
                    </button>
                  </div>
                </div>

                {/* Settings Info */}
                <div className="mt-6 pt-4 border-t border-border">
                  <div className="bg-muted rounded-md p-3">
                    <div className="flex items-center space-x-2 mb-2">
                      <Icon name="Info" size={14} className="text-primary" />
                      <span className="text-xs font-medium text-foreground">Settings Status</span>
                    </div>
                    <div className="space-y-1 text-xs text-muted-foreground">
                      <div className="flex justify-between">
                        <span>Last Updated:</span>
                        <span>Jan 20, 2024</span>
                      </div>
                      <div className="flex justify-between">
                        <span>Auto-Save:</span>
                        <span className="text-success">Enabled</span>
                      </div>
                      <div className="flex justify-between">
                        <span>Sync Status:</span>
                        <span className="text-success">Synced</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Main Content Area */}
            <div className="flex-1 min-w-0">
              <div className="bg-card border border-border rounded-lg">
                <div className="p-6">
                  {renderTabContent()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;